import Lottie from 'lottie-react';
import LottieLoading from '@/assets/LottieLoading.json';
import NewSerpForm from '@/app/Serp/components/common/NewSerpForm';

const NoSerpData = () => {
  return (
    <div className="d-flex flex-column gap-3 justify-content-center align-items-center">
      <NewSerpForm />
      <div
        className="mb-3 text-center"
        style={{ width: '250px', margin: 'auto' }}
      >
        <Lottie animationData={LottieLoading} />
      </div>
      <div className="mt-6 fw-medium text-center">
        برای شروع SERP کلمه رو وارد کن و دکمه جستجو رو بزن.
      </div>
    </div>
  );
};

export default NoSerpData;
